import type { PATHS } from 'constants/pathsB2b';
import type { DiscoveryCover } from './discovery';

export enum GameIdentifier {
  ROULETTE = 0,
  AIRCONSOLE = 1,
  THIS_IS_BLINDTEST = 2,
}

export interface Game {
  id: string;
  identifier: GameIdentifier;
  name: string;
  coverFilename: string;
  path?: (typeof PATHS)[keyof typeof PATHS];
  url?: string;
  onClick?: () => void;
  in_app?: boolean;
  controllerUrl?: string;
  displayUrl?: string;
}

export const isGameCover = (cover: DiscoveryCover) => {
  return (cover as Game).identifier !== undefined;
};
